import { type AppInstallation, INSTALLATION } from './app-common';

import type { ShareButtonType } from 'src/interfaces';

const SHARE_BUTTONS_CONFIG: Partial<Record<AppInstallation | 'default', ShareButtonType[]>> = {
  default: ['whatsapp', 'facebook', 'twitter', 'email', 'copy'],
  hebrew: ['whatsapp', 'telegram', 'facebook', 'email', 'copy'],
};

export const SHARE_BUTTONS = SHARE_BUTTONS_CONFIG[INSTALLATION] || SHARE_BUTTONS_CONFIG.default!;
